import React, { useEffect, useState } from 'react'
//import { songsData } from '../data/songsData'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import { FiEdit } from "react-icons/fi";
import { IoDuplicateOutline } from "react-icons/io5";
import BlueButton from '../components/BlueButton';
import { generateMongoDBId } from '../whitaijiFrontendLibrary/lib/utils';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { useQueryClient, useQuery, } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { _CREATE, _UPDATE } from '../utils/patches';
import { errorAlert, successAlert } from '../utils/utils';
import { useStateContext } from '../context/StateContext';
//import { dT } from '../components/Translation';
import { blueColour } from './Home';
import T from '../components/Translation';
//import { GiStarsStack } from "react-icons/gi";
import TextField from '../whitaijiFrontendLibrary/components/TextField';
import TrueFalseToggle from '../whitaijiFrontendLibrary/components/TrueFalseToggle';
import { IoIosSettings } from "react-icons/io";
import AddButton from '../whitaijiFrontendLibrary/components/AddButton';
import { songsData } from '../data/songsData';
import { newSongsData } from '../data/newSongsData';
import LogMusicPlayer from '../components/LogMusicPlayer';
import { CiTimer } from "react-icons/ci";
import TextHighlight from '../components/TextHighlight';
import AddAudioFileToS3 from '../components/AddAudioFIleToS3';
import { FaRegPlayCircle } from "react-icons/fa";




const ManageSongs = () => {

    const [song, setSong] = useState()
    const [title, setTitle] = useState(song?.title)
    const [isWithPrelude, setIsWithPrelude] = useState(song?.isWithPrelude)
    const [shortDescription, setShortDescription] = useState(song?.shortDescription)
    const [longDescription, setLongDescription] = useState(song?.longDescription)
    const [topic, setTopic] = useState(song?.topic)
    const [imageName, setImageName] = useState(song?.lyrics)
    const [soundSource, setSoundSource] = useState(song?.soundSource)

    const [edit, setEdit] = useState(false)
    const [viewSongSettings, setViewSongSettings] = useState(false)
    const [currentSecond, setCurrentSecond] = useState(23)
    const [addSeconds, setAddSeconds] = useState(0)
    const {hideTestButtons, language, apiUrl} = useStateContext()
    const addSecondsToAll = () => {
        const newSong = {...song, lyrics: song?.lyrics?.map((x) => ({...x, time: Number(x?.time) + Number(addSeconds)}))}
        process.env.NODE_ENV === "development" && console.log("newSong", newSong)
        setSong(newSong)
    }

    useEffect(() => {
       setTitle(song?.title) 
       setIsWithPrelude(song?.isWithPrelude)
       setShortDescription(song?.shortDescription)
       setLongDescription(song?.longDescription)
       setTopic(song?.topic)
       setImageName(song?.imageName)
       setSoundSource(song?.soundSource)
    },[song])   

    const { user } = useAuthContext(AuthContext)
    const navigate = useNavigate();
    
    const queryClient = useQueryClient()

         const emptySongDoc = () => ({
           _id: generateMongoDBId(),
           title: "",
           longDescription: "",
           shortDescription: "",
           soundSource: "",
           topic: "",
           imageName: "",
           isWithPrelude: false,
           lyrics: [],
         })


      const createSong = () => { 
            setSong(emptySongDoc())
            setEdit(true)
         }
      const resetSong = () => setSong(emptySongDoc()) 
      const deleteSong = () => setSong(undefined)
      const backToHome = () => {
        window.scrollTo(0, 0);
        navigate('/');
        }
        const [error, setError] = useState(null);
      
      const onError = (e) => {
        setError(e.error);
        errorAlert(e.error || 'Failed to save song');
      
      }
    
      const onSuccess = (json, songExists) => {
        if (json.error) {
          setError(json.error);
          errorAlert(json.error);
          return;
        }
        setError(null);
        const message = songExists ? 'Song edited successfully!' : 'Song saved successfully!';
        successAlert(message);
      }
      // Fetch user's songs
      const { data: songsDataDb } = useQuery({
        queryKey: ['songsData'],
        queryFn: async () => {
          try {
            const response = await fetch(`${apiUrl}/songs`, {
              headers: {
                'Authorization': `Bearer ${user.token}`
              }
            });
            const data = await response.json();
            process.env.NODE_ENV === "development" && console.log("songs loaded", data)
            return data;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching songs:', error);
            return [];
          }
        },
        enabled: !!user // Only fetch if user is logged in
      });
    const { mutate: addSong, isLoading } = useMutation({
        mutationFn: async(song) => {
          try {
            if (song?._id) {
              // Check if song exists in user's songs
              const songExists = songsDataDb?.some(x => x._id === song._id);
              
              if (songExists) {
                // Update existing song
                const response = await _UPDATE({
                  doc: song, 
                  user, 
                  route: `${apiUrl}/songs/${song._id}`, 
                  onError
                });
                onSuccess(response, songExists);
                return response;
              } else {
                // Create new song if it doesn't exist
                return await _CREATE({
                  doc: { ...song }, // Remove _id for new creation
                  user, 
                  route: `${apiUrl}/songs`, 
                  onError, 
                  onSuccess
                });
              }
            } else {
              // Create new song
              return await _CREATE({
                doc: song, 
                user, 
                route: `${apiUrl}/songs`, 
                onError, 
                onSuccess
              });
            }
          } catch (error) {
            onError(error);
            throw error;
          }
        },
        onSettled: () => queryClient.invalidateQueries({ queryKey: ['songsData'] }),
        mutationKey: ['songsData'],
      });
    const saveSong = () => {
        process.env.NODE_ENV === "development" && console.log("save song", song)
        addSong(song)
    }
    const areIdsMissing = song?.lyrics?.every((x) => !x?._id)
    const add_ids = () => {
        setSong({...song, lyrics: song?.lyrics?.map((x) => ({...x, _id: generateMongoDBId()}))})
    }
    const logSeconds = (seconds) => {
        //process.env.NODE_ENV === "development" && console.log("log seconds", seconds)
        setCurrentSecond(seconds)
    }

    const addLyric = () => {
        setSong({...song, lyrics: [...song?.lyrics, {text: "", time: 0, _id: generateMongoDBId()}]})
    }
   const updateSongSoundSource = (newSoundSource) => {
        setSoundSource(newSoundSource)
        setSong({...song, soundSource: newSoundSource})
   }
   const testFunction = () => {
       process.env.NODE_ENV === "development" && console.log("aòoemelrk", {song, currentSecond})
   }
   const songsSource = songsDataDb // songsData // newSongsData // songsDataDb
   const songSourceWithInterlude = !Array.isArray(songsSource) ? [] : songsSource?.filter((x) => x?.isWithPrelude)
   const songSourceWithoutInterlude =  !Array.isArray(songsSource) ? [] : songsSource?.filter((x) => !x?.isWithPrelude)
   const staticSoundSource = songsSource?.find((x) => x?._id == song?._id)?.soundSource
  return (
    <div style={{padding: "30px"}}>
        <VisDiv rules={[!song]}>
            <div style={{textAlign: "center", marginBottom: "20px"}}>
                <h3>Manage Songs</h3>
            </div>
            <BlueButton home />
            <BlueButton color={"green"}hide={false} text={<T obj={{en: "Create Song", it: "Crea Canzone"}} />} fn={createSong}/>
            {songSourceWithoutInterlude?.map((item, index) => <SongPin key={index} setSong={setSong} song={song} data={{songItem: item}} />)}

            <VisDiv rules={[songSourceWithInterlude?.length > 0]}>
                <h3 style={{margin: "20px 0px 20px 0px"}}>
                    {<T obj={{en: "Songs With Interlude", it: "Canzoni con interludio"}} />}
                </h3>
                {songSourceWithInterlude?.map((item, index) => <SongPin key={index} setSong={setSong} song={song} data={{songItem: item}} />)}
            </VisDiv>
        </VisDiv>
        <VisDiv rules={[song]}> 
        <div style={{display: "flex", justifyContent: "flex-start"}}>
            <BlueButton hide={false} text={"Test Song"} fn={testFunction}/>
            <VisDiv rules={[areIdsMissing]}>
                <BlueButton color={"orange"} hide={false} text={<T obj={{en: "Add _ids to lyrics", it: "Aggiungi _ids alle canzoni"}} />} fn={add_ids}/>
            </VisDiv>
            <BlueButton color={"green"}hide={false} text={<T obj={{en: "Save Song", it: "Salva Canzone"}} />} fn={saveSong}/>
            <BlueButton textColour={blueColour} color={"yellow"}hide={false} text={<T obj={{en: "Reset Song", it: "Resetta Canzone"}} />} fn={resetSong}/>
            <BlueButton color={"red"} hide={false} text={<T obj={{en: "Close Song", it: "Chiudi Canzone"}} />} fn={deleteSong}/>
        </div>
        <AddAudioFileToS3 fileId={song?._id} saveFn={(url) => {
            setSoundSource(url);
            setSong({...song, soundSource: url});
        }}/>
        <VisDiv rules={[!areIdsMissing, staticSoundSource]} >
            <LogMusicPlayer
                hideTestButtons={hideTestButtons}
                secondsOnly={true}
                songSource = {staticSoundSource}
                //title={song?.title}
                lyrics={!edit ? song?.lyrics : undefined }
                logSeconds={logSeconds}
            />
        </VisDiv>
        <VisDiv rules={[areIdsMissing]}>
            <div style={{textAlign: "center", marginBottom: "20px"}}>
                <h3>Lyrics Ids Missing</h3>
            </div>
        </VisDiv>

            <div style={{textAlign: "center", marginBottom: "20px",display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row"}}>
                <VisDiv rules={[!edit]}>
                     <div style={{display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "flex-end"}}>
                        <FiEdit 
                            style={{cursor: 'pointer', marginLeft: '10px'}} 
                            size={25} 
                            onClick={() => setEdit(!edit)}
                        />
                        <IoIosSettings 
                            style={{cursor: 'pointer', marginLeft: '10px'}} 
                            size={25} 
                            onClick={() => setViewSongSettings(!viewSongSettings)}
                        />
                    </div>
                    <div>
                        <h1> {title} </h1>
                    </div>
                    <VisDiv rules={[viewSongSettings]}>
                        <VisDiv style={{marginTop: "10px"}} rules={[isWithPrelude]}>
                            <TextHighlight highlight={"green"}>
                                <T obj={{en: "With Interlude", it: "Con Interludio"}} />
                            </TextHighlight>        
                        </VisDiv>
                        <VisDiv rules={[soundSource]} style={{marginTop: "10px"}}>
                            <h3 style={{textAlign: "center", margin: "10px"}}><T obj={{en: "Song Source:", it: "Fonte Canzone:"}} /></h3>
                            <TextHighlight highlight={"green"}>
                                {soundSource}
                            </TextHighlight>  
                        </VisDiv> 
                        <VisDiv rules={[shortDescription]} style={{marginTop: "10px"}}>
                            <h3 style={{textAlign: "center", margin: "10px"}}><T obj={{en: "Short Description:", it: "Descrizione Breve:"}} /></h3>
                            {shortDescription}
                        </VisDiv>
                        <VisDiv rules={[longDescription]} style={{marginTop: "10px"}}>
                        <h3 style={{textAlign: "center", margin: "10px"}}><T obj={{en: "Long Description:", it: "Descrizione Lunga:"}} /></h3>
                            {longDescription}
                        </VisDiv>
                        <VisDiv rules={[imageName]} style={{marginTop: "10px"}}>
                        <h3 style={{textAlign: "center", margin: "10px"}}><T obj={{en: "Image Name:", it: "Nome Immagine:"}} /></h3>
                            {imageName}
                        </VisDiv>
                        <VisDiv rules={[topic]} style={{marginTop: "10px"}}>
                            <h3 style={{textAlign: "center", margin: "10px"}}><T obj={{en: "Song Topic:", it: "Tema Canzone:"}} /></h3>
                            <TextHighlight highlight={"green"}>
                                {topic}
                            </TextHighlight>  
                        </VisDiv>  
                    </VisDiv>
                </VisDiv>
                <VisDiv style={{display: "flex", width: "80%", flexDirection: "column"}} rules={[edit]}>
                    <div style={{display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "flex-end"}}>
                        <FiEdit 
                            style={{cursor: 'pointer', marginLeft: '10px'}} 
                            size={25} 
                            onClick={() => setEdit(!edit)}
                        />
                        <IoIosSettings 
                            style={{cursor: 'pointer', marginLeft: '10px'}} 
                            size={25} 
                            onClick={() => setViewSongSettings(!viewSongSettings)}
                        />
                    </div>
                    <TextField 
                        label={<T obj={{en: "Song Title", it: "Titolo Canzone"}} />}
                        type="text" 
                        value={title} 
                        onChange={(e) => {setTitle(e.target.value)}} 
                        onBlur={(e) => {setSong({...song, title: e.target.value})}}
                    />
                    <VisDiv rules={[viewSongSettings]}>
                        <div style={{marginTop: "10px"}}>
                            <TrueFalseToggle value={isWithPrelude} onClick={() => {setSong({...song, isWithPrelude: !isWithPrelude})}} label={<T obj={{en: "With Interlude", it: "Con Interludio"}} />} />
                        </div>
                        <div style={{marginTop: "10px"}}>
                            <TextField
                                label={<T obj={{en: "Song Source", it: "Fonte Canzone"}} />}
                                type="text" 
                                value={soundSource} 
                                onChange={(e) => {setSoundSource(e.target.value)}} 
                                onBlur={(e) => {setSong({...song, soundSource: soundSource})}}
                            />
                        </div>
                        <div style={{marginTop: "10px"}}>
                            <TextField
                                label={<T obj={{en: "Song Topic", it: "Tema Canzone"}} />}
                                type="text" 
                                value={topic} 
                                onChange={(e) => {setTopic(e.target.value)}} 
                                onBlur={(e) => {setSong({...song, topic: topic})}}
                            />
                        </div>
                        <div style={{marginTop: "10px"}}>
                            <TextField
                                label={<T obj={{en: "Image Name", it: "Nome Immagine"}} />}
                                type="text" 
                                value={imageName} 
                                onChange={(e) => {setImageName(e.target.value)}} 
                                onBlur={(e) => {setSong({...song, imageName: imageName})}}
                            />
                        </div>
                        <div style={{marginTop: "10px"}}>
                            <TextField
                                label={<T obj={{en: "Short Description", it: "Descrizione breve"}} />}
                                type="text" 
                                value={shortDescription} 
                                onChange={(e) => {setShortDescription(e.target.value)}} 
                                onBlur={(e) => {setSong({...song, shortDescription: shortDescription})}}
                            />
                        </div>
                        <div style={{marginTop: "10px"}}>
                            <p style={{marginBottom: "10px", fontWeight: "bold"}}><T obj={{en: "Long Description:", it: "Descrizione lunga:"}} /></p>
                            <textarea 
                                className="text-area-input"
                                onChange={(e) => setLongDescription(e.target.value)}
                                value={longDescription}
                                onBlur={() => setSong({...song, longDescription: longDescription})}
                            />
                        </div>
                    </VisDiv>
                </VisDiv>
            </div>
            <VisDiv rules={[!edit]}>
                {!Array.isArray(song?.lyrics) ? [] : song?.lyrics
                //?.sort((a, b) => a?.time - b?.time)
                //?.filter((x)=> x?.time !== 0)
                ?.map((lyric, index) => {
                return ( 
                    <div key={index}> 
                            {lyric?.firstLineInParagraph && <div style={{marginTop: "30px", marginBottom: "30px"}}>
                                <h3>{lyric?.sectionTitle}</h3>
                                </div>}
                                <div style={{margin:"10px", display:"flex", alignItems:"center", padding:"3px",}}>      
                            <div>
                                {lyric.text}
                            </div>
                        </div>
                    </div>)
                })
                    }
            </VisDiv>
            <VisDiv rules={[edit]}>
                <div>
                    <h3><T obj={{en: "Add Seconds To All Times", it: "Aggiungi Secondi a tutti i tempi"}} /></h3>
                    <div style={{marginRight:"10px", width:"70px"}}>
                        <TextField 
                            type="number" 
                            value={addSeconds} 
                            onChange={(e) => {setAddSeconds(e.target.value)}}
                            onBlur={addSecondsToAll}
                        />
                    </div>
                </div>
                {!Array.isArray(song?.lyrics) ? [] : song?.lyrics
                //?.sort((a, b) => a?.time - b?.time)
                //?.filter((x)=> x?.time !== 0)
                ?.map((lyric, index) => {
                return ( 
                    <div key={index}> 
                        {lyric?.firstLineInParagraph && <div style={{marginTop: "25px", marginBottom: "25px"}}>
                            <h3>{lyric?.sectionTitle}</h3>
                            </div>}
                        <LyricPin setSong={setSong} song={song} data={{lyric, currentSecond, hideTestButtons}} />
                    </div>)
                })
                    }
                 <AddButton label={<T obj={{en: "Add Lyric", it: "Aggiungi Linea"}} />} onClick={addLyric} />
            </VisDiv>
           

        </VisDiv>
       
    </div>
  )
}

export default ManageSongs

export const SongPin = ({data, songLogs, song, setSong=()=>{}, hideEdit}) => {
    const {songItem} = data
    return (
        <div style={{padding: "3px", display: "flex", alignItems: "center", maxWidth: "400px", justifyContent: "space-between", display: "flex", alignItems: "center", cursor: "pointer", flexDirection: "row", borderRadius: "10px", minHeight: "40px", paddingLeft: "10px", marginBottom: "10px", backgroundColor: "#d3d3d3", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"}}>
            {songItem?.title}
            <div style={{display:"flex"}}>
                <VisDiv rules={[!hideEdit]}>
                    <FiEdit 
                        style={{cursor: 'pointer', marginLeft: '20px'}} 
                        size={20} 
                        onClick={() => setSong(songItem)}
                        />
                </VisDiv>
                <VisDiv rules={[!hideEdit]}>
                    <IoDuplicateOutline
                        style={{cursor: 'pointer', marginLeft: '20px'}} 
                        size={20} 
                        onClick={() => setSong({...songItem, _id: generateMongoDBId()})}
                    />
                </VisDiv>
                <VisDiv style={{display :"flex", alignItems: "center", marginLeft: "20px", marginRight: "20px"}} rules={[songLogs?.length > 0]}>
                    <FaRegPlayCircle style={{marginRight: "5px"}} size={23}/>
                    <h3>{songLogs?.length}</h3>
                 </VisDiv>   
            </div>


        </div>
    )
}

export const LyricPin = ({data, song, setSong=()=>{}}) => {

    const {lyric, currentSecond, hideTestButtons} = data 
    const [viewSettings, setViewSettings] = useState(false)
    const [time, setTime] = useState(lyric?.time)
    const [text, setText] = useState(lyric?.text)
    const [sectionTitle, setSectionTitle] = useState(lyric?.sectionTitle)
    const [firstLineInParagraph, setFirstLineInParagraph] = useState(lyric?.firstLineInParagraph)

    const onBlurText = (key, value) => {
        setSong({
            ...song, 
            lyrics: song?.lyrics?.map((x) => 
                {
                    if (x?._id === lyric?._id) {return {...x, [key]: value}} 
                    else return x}
                )})
    }
    const logSeconds = ()=>{
            const log = currentSecond
            process.env.NODE_ENV === "development" && console.log("timeLog", log)
           
            setTime(log)
            onBlurText("time", Number(log))
            }
    
    const toggleFirstLineInParagraph = () => {
        process.env.NODE_ENV === "development" && console.log("PIN CLICKED")
        setFirstLineInParagraph(!firstLineInParagraph)
        onBlurText("firstLineInParagraph", !firstLineInParagraph)
    }

    
    return (
        <>
        <div style={{display:"flex", alignItems:"center", flexDirection:"row", marginTop:"-18px"}}>      
                <div style={{marginRight:"10px", width:"70px"}}>
                    <TextField 
                        type="number" 
                        value={time} 
                        onChange={(e) => {setTime(e.target.value)}}
                        onBlur={(e) => {onBlurText("time", Number(time))}} 
                    />
                </div>
                <div style={{marginRight:"10px", cursor:"pointer"}} onClick={logSeconds}>
                    <CiTimer size={25} />
                </div>
                <div style={{marginRight:"10px", width:"100%"}}>
                    <TextField 
                        type="text" 
                        value={text} 
                        onChange={(e) => {setText(e.target.value)}} 
                        onBlur={(e) => {onBlurText("text", text)}}
                    />
                </div>
                <div style={{marginRight:"10px"}} onClick={() => setViewSettings(!viewSettings)}>
                    <IoIosSettings size={20} />
                </div>
        </div>
        <VisDiv rules={[viewSettings]} style={{display:"flex", alignItems:"center", flexDirection:"row", marginTop:"-30px"}}> 
            <div>
                <TrueFalseToggle 
                    value={firstLineInParagraph} 
                    onClick={toggleFirstLineInParagraph} 
                    label={"First Line In Paragraph"} 
                    descriptionDivider={false} 
                />
            </div>
            <VisDiv style={{marginLeft:"15px", marginRight:"15px", display:"flex", alignItems:"center", flexDirection:"row"}} rules={[firstLineInParagraph]}>
                <p style={{marginRight:"10px", fontWeight:"bold"}}>Section Title:</p>
                <TextField 
                    type="text" 
                    value={sectionTitle} 
                    onChange={(e) => {setSectionTitle(e.target.value)}} 
                    onBlur={(e) => {onBlurText("sectionTitle", sectionTitle)}}
                />
            </VisDiv>
        </VisDiv> 
{/*         <VisDiv style={{border:"1px dotted #ccc", marginLeft:"30px", padding:"10px", color:"gray"}} rules={[false]}>
            <div style={{marginBottom:"10px", display:"flex", alignItems:"center"}}>
                <div style={{marginRight:"10px"}}>
                 <GiStarsStack size={18}/>
                </div>
                <div style={{fontWeight:"bold"}}>
                    <T obj={{en:"reMind ai says:", it: "reMind ia spiega:"}}/>
                </div>
                
            </div>
            <p>{lyric?.aiDescription}</p>
        </VisDiv> */}
        </>
    )
}
